import React, { Component } from "react";
import { Route, Routes } from "react-router-dom";
import Login from "../components/pages/Login";
import PointsOfActionCaseList from "../components/pages/PointsOfActionCaseList";
import PointsUploadOptionList from "../components/pages/PointsUploadOptionList"
import UserList from "../components/pages/UserList"
import { AUTH_TOKEN } from '../constants'
import ChangePassword from "../components/pages/ChangePassword";
import LabelList from "../components/pages/LabelList";
import PaymentList from "../components/pages/PaymentList";
import DeviceLoggerList from "../components/pages/DeviceLoggerList";
import TicketList from "../components/pages/TicketList";
import SavedTranslationList from "../components/pages/SavedTranslationsList";
import EntrySuggestionList from "../components/pages/EntrySuggestionList";
import MobileTemplateList from "../components/pages/MobileTemplateList";
import MailTemplateList from "../components/pages/MailTemplateList";
import HeaderWithLocation from "../components/elements/Header";
import AdvertisementLogStatistic from "../components/pages/AdvertisementLogStatistic";


class App extends Component {
  
  render() {
    const token = localStorage.getItem(AUTH_TOKEN)

    return (
      <div className="App"> 
        <HeaderWithLocation/>
        <div className="main">
          <Routes>
              <Route path="/" element={token ? <UserList /> : <Login/>} />
              <Route path="/tickets" element={<TicketList />} />
              <Route path="/points-of-action-case" element={<PointsOfActionCaseList />} />
              <Route path="/login" element={<Login/>} />
              <Route path="/points-upload-option" element={<PointsUploadOptionList />} />
              <Route path="/users" element={<UserList />} />
              <Route path="/labels" element={<LabelList />} />
              <Route path="/payments" element={<PaymentList />} />
              <Route path="/device-logs" element={<DeviceLoggerList/>} />
              <Route path="/mobil-templates" element={<MobileTemplateList/>} />
              <Route path="/mail-templates" element={<MailTemplateList/>} />
              <Route path="/translations" element={<SavedTranslationList/>} />
              <Route path="/entry-suggestion" element={<EntrySuggestionList/>} />
              <Route path="/change-password"  element={<ChangePassword/>} /> 
              <Route path="/statistics/advertisement-logs"  element={<AdvertisementLogStatistic/>} /> 
          </Routes>
        </div>
      </div>
    )
  }
}

export default App;